var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8ad5504800678307165eea6a53f4bff0.js').default;export default
        Object.assign({}, scope_0 )
    